export default "__VITE_ASSET__FdZ28XoM__"